export const scrollToTop = (behavior: ScrollBehavior = 'instant') => {
    window.scrollTo({top: 0, left: 0, behavior: behavior});
};
